<script setup>
import {useReportOutput} from "@/components/report/outputs/useReportOutput";

const props = defineProps({
  value: [String, Object]
})

const {v, extra} = useReportOutput(props)

</script>

<template>
  <b-btn size="sm" @click="rfApp(extra.path, extra.params)">{{ v }}</b-btn>
</template>

<style scoped>

</style>